import { useState, useEffect } from 'react';
import { BpmServiceall } from '../../../../core/services/BpmServiceall';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import { PrintJson } from '../../../theme/Component/PrintJson';

interface Props {
    label: string;
    idSelector: number;
    groupDefinition: string;
    onChange: (value: number | any) => void;
    returnType?: "ID" | "Object";
    compareKey?: string;
}

export const CRSelectorConstants = ({ label, idSelector, groupDefinition, onChange, returnType = "ID", compareKey = "IDCreditProperties" }: Props) => {
    const service = new BpmServiceall();
    const [lista, setLista] = useState<any[]>([]);
    const [row, setRow] = useState<any>({});
    const modal = useModal(label ?? 'Seleccione', MODAL_md);

    useEffect(() => {
        if (groupDefinition) {
            getLista();
        }
    }, [groupDefinition]);

    useEffect(() => {
        if (row?.[compareKey]) {
            onChange(returnType === "Object" ? row : row[compareKey]);
        }
    }, [row]);

    const getLista = () => {
        let data = _single.getSessionItem("par_" + groupDefinition);
        if (data) {
            setLista(JSON.parse(data));
        } else {
            service.getCreditPropertyDefinition(null, null, groupDefinition).subscribe(
                (resp: any) => {
                    const list = resp?.DataBeanProperties?.ObjectValue?.DataBeanProperties?.List;
                    if (list?.length > 0) {
                        _single.setSessionItem("par_" + groupDefinition, JSON.stringify(list));
                        setLista(list);
                    }
                }
            );
        }
    };

    const head = [
        { title: 'ID', property: 'IDCreditProperties', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Description', visible: true },
    ];

    return (
        <>
            <label>{label ?? 'Seleccione'}</label>
            {lista.length < 10 ? (
                <select
                    className="form-control"
                    value={String(idSelector) || ""}
                    onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedItem = lista.find(
                            (item) => String(item.DataBeanProperties[compareKey]) === selectedId
                        );

                        onChange(
                            selectedId === "" ? null
                                :
                                returnType === "Object" ? selectedItem?.DataBeanProperties : selectedItem?.DataBeanProperties?.[compareKey]
                        );
                    }}

                >
                    <option value="">...</option>
                    {lista.map((item) => {
                        const value = item.DataBeanProperties;
                        return (
                            <option key={value.IDCreditProperties} value={String(value[compareKey])}>
                                {value.Description}
                            </option>
                        );
                    })}
                </select>
            ) : (
                <>
                    <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={
                            lista.find(
                                (el) => String(el.DataBeanProperties[compareKey]) === String(idSelector)
                            )?.DataBeanProperties.Description ?? ""
                        }
                        placeholder="Seleccione"
                        onClick={() => modal.open()}
                    />

                    <Modal modal={modal.modal} updateModal={modal.setModal}>
                        <BasicTable head={head} body={lista} rowSet={setRow} />
                    </Modal>
                </>
            )}
        </>
    );
};

